import React, { Component } from 'react';
import { IoLogoJavascript } from 'react-icons/io';
import { FaSalesforce } from 'react-icons/fa';
import { FaPython } from 'react-icons/fa';
import { FaReact } from 'react-icons/fa';
import { FaBootstrap } from 'react-icons/fa';
import { FaNodeJs } from 'react-icons/fa';
import { FaGitSquare } from 'react-icons/fa';
import { SiMongodb } from 'react-icons/si';
import { SiJquery } from 'react-icons/si';
import { SiHeroku } from 'react-icons/si';
import { FaSwift } from 'react-icons/fa';
import { FaApple } from 'react-icons/fa';




class Resume extends Component {
  render() {

    const skillSpacing = {
      wordSpacing: 10
    }
    
    if(this.props.data){
      var skillmessage = this.props.data.skillmessage;
      var education = this.props.data.education.map(function(education){
        return <div key={education.school}><h3>{education.school}</h3>
        <p className="info">{education.degree} <span>&bull;</span><em className="date">{education.graduated}</em></p>
        <p>{education.description}</p></div>
      })
      var work = this.props.data.work.map(function(work){
        return <div key={work.company}><h3>{work.company}</h3>
            <p className="info">{work.title}<span>&bull;</span> <em className="date">{work.years}</em></p>
            <p>{work.description}</p>
        </div>
      })
      var skills = this.props.data.skills.map(function(skills){
        var className = 'bar-expand '+skills.name.toLowerCase();
        return <li key={skills.name}><span style={{width:skills.level}}className={className}></span><em>{skills.name}</em></li>
      })
    }

    return (
      <section id="resume">

      <div className="row education">
         <div className="three columns header-col">
            <h1><span>Education </span></h1>
         </div>

         <div className="nine columns main-col">
            <div className="row item">
               <div className="twelve columns">
                 {education}
               </div>
            </div>
         </div>
      </div>


      <div className="row work">

         <div className="three columns header-col">
            <h1><span>Work</span></h1>
         </div>

         <div className="nine columns main-col">
          {/* {work} */}

          <h3>Canada Goose</h3>
          <p className="info">Salesforce Commerce Cloud Developer </p>
          <p className="info">March 2021 - Ongoing </p>
          <ul>
  <li>-Develop and maintain SFCC content assets for Canada Goose’s flagship website using front end stack: HTML, CSS, SCSS, JavaScript, and Jquery </li>
  <li>-Utilize page designer to build components and assets with prebuilt solutions and with custom code </li>
  <li>-SEO management and maintenance to guide customers to featured products and pages, thereby increasing company revenue</li>
  <li> -Build and maintain SFCC cartridges with ISML templates, NodeJS, Javascript</li>
  <li>-SFCC legacy migration to Salesforce Storefront Reference Architecture (SFRA) for Canada Goose’s website to reflect modern mobile first philosophy</li>
  <li>Collaborated with various departments and teams such as marketing and QA via scrum and agile</li>
</ul>

          {/* <h3>QHR Technologies</h3>
          <p className="info">Client Services Analyst - Accuro Configuration Specialist</p>
          <p className="info">January 2021 -March, 2022 </p>
          <ul>
  <li>-Consulted Clients with their Electronic Medical Software - Accuro by teaching workflows, thereby increasing client satisfaction </li>
  <li>-Configured Accuro software when necessary for clients with unique setup requirements </li>
  <li>-Made outbound calls and received inbound calls to discuss client issues and resolving them</li>
  <li> -Acted as a mediator between Development and Clients by discovering software bugs and bringing attention to them</li>
  <li>-Utilize Salesforce Service Cloud to track and resolve cases thereby increasing Client retention and satisfaction</li>
</ul>

          <h3>iTTTi Japan</h3>
          <p className="info">English Teacher</p>
          <p className="info">May 2018 - August 2020</p>
          <ul>
  <li>-Planned and taught lessons to young students to ensure interest and student retention</li>
  <li>-Managed students by being an authority figure and role model for Canadians </li>
  <li>-Performed administrative duties: writing reports, planning meetings, lesson plans</li>
  <li>-Constant client facing environment, interacted with both students and parents</li>
  <li>-Strong public speaking role; regularly spoke in front of students and parents</li>
  <li>-Sales involvement; promoted special lessons as a major source of revenue for the company</li>
</ul> */}


{/* For the JSON projects

// {
      //   "title":"Hacker News API in React",
      //   "category":"A simple search engine using Hacker News API, made in React",
      //   "image":"hacker_news_api_react.png",
      //   "url":"https://murmuring-brushlands-38328.herokuapp.com/"
      // },
      // {
      //   "title":"RGB Color Game",
      //   "category":"Simple RGB color game made using Vanilla JS, HTML, and CSS only.",
      //   "image":"RGB_colour_game.png",
      //   "url":"https://rgb-simon-game.herokuapp.com/"
      // }, */}

         <h3>Stratus360</h3>
         <p className="info">Software Developer Intern</p>
         <p className="info">July 2017 - November 2017</p>
         <ul>
  <li>-Developed a wizard application for major financial clients on the Salesforce platform to better understand the needs of the customers</li>
  <li>-Implemented front-end requirements to ensure application looks polished and presentable </li>
  <li>-Resolved client’s complaints and requirements throughout the development process by involving the client in the application via Agile methodology</li>
  <li>-Worked with HTML, CSS, JavaScript, Apex, Lightning Components, GIT for the stack</li>
  <li>-Debugged code for front-end and back-end, performed unit tests to ensure a proper deployment</li>
</ul>
        </div>
    </div>



      <div className="row skill">

         <div className="three columns header-col">
            <h1><span>Skills</span></h1>
         </div>

         <div className="nine columns main-col">
         
            <p>{skillmessage}
            </p>

				<div className="bars">
				   <ul className="skills">
					  {/* {skills} */}
            
            <p style={skillSpacing}>HTML <i className="fa fa-html5"></i> Python <FaPython/> Jquery <SiJquery/> </p>
            <p style={skillSpacing}>CSS <i className="fa fa-css3"> </i> React <FaReact/> Heroku <SiHeroku/></p>
            <p style={skillSpacing}>Javascript <IoLogoJavascript/> Bootstrap <FaBootstrap/>  Salesforce <FaSalesforce/></p>
            <p style={skillSpacing}>NodeJS <FaNodeJs/> MongoDB <SiMongodb/> Git <FaGitSquare/> </p>
            <p style={skillSpacing}>SFCC <FaSalesforce/> Swift <FaSwift/> iOS <FaApple/></p>
            
      
					</ul>
				</div>
			</div>
      </div>
   </section>
    );
  }
}

export default Resume;



// WEBPACK FOOTER //
// ./src/Components/Resume.js